<template>
    <div class="faq">
        <h2 class="page__title title title--m">Правила пользования</h2>
        <div class="faq__items">
            <div class="faq__section" v-for="category in faq">
                <span class="faq__section-name">{{ category.title }}</span>
                <questions v-if="category.feedback.length" :questions="category.feedback"></questions>
            </div>
        </div>
        <answer></answer>
    </div>
</template>

<script>
    import {store} from "../../store/faq";
    import {mapState} from 'vuex';
    import Questions from "./modules/Questions";
    import Answer from "./modules/Answer";

    export default {
        name: "faq",
        components: {Answer, Questions},
        store,
        computed: {
            ...mapState([
                'faq',
            ]),
        },
    }
</script>
